export default "__VITE_ASSET__DXuRNtRp__"